(function() {
  var $23ed9a0ef8499685$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("product-form-gift-card")) return;
    const MESSAGE_LIMIT_FALLBACK = 200;
    const MESSAGE_NEAR_LIMIT_THRESHOLD = 160;
    customElements.define("product-form-gift-card", class ProductFormGiftCard extends HTMLElement {
      currentVariantId=null;
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onProductFormStateUpdated = this.onProductFormStateUpdated.bind(this);
        this.onProductFormAddError = this.onProductFormAddError.bind(this);
        this.onProductFormAddSuccess = this.onProductFormAddSuccess.bind(this);
        this.onMessageInput = this.onMessageInput.bind(this);
      }
      connectedCallback() {
        this.productForm = this.closest("product-form");
        this.checkbox = this.querySelector("[data-recipient-checkbox]");
        this.hiddenControlField = this.querySelector("[data-recipient-control]");
        this.offsetField = this.querySelector("[data-recipient-offset]");
        this.liveRegion = this.querySelector("[data-recipient-live-region]");
        this.errorSummary = this.querySelector("[data-recipient-summary]");
        this.errorSummaryList = this.errorSummary?.querySelector("ul");
        this.errorFieldEls = this.querySelectorAll("[data-recipient-field-error]");
        this.inputs = Array.from(this.querySelectorAll("[data-recipient-field]"));
        this.messageCounter = this.querySelector("[data-recipient-message-count]");
        this.inputMap = {
          email: this.querySelector("[data-recipient-email]"),
          name: this.querySelector("[data-recipient-name]"),
          message: this.querySelector("[data-recipient-message]"),
          send_on: this.querySelector("[data-recipient-send-on]")
        };
        this.errorMap = {
          email: this.querySelector('[data-recipient-field-error][data-field="email"]'),
          name: this.querySelector('[data-recipient-field-error][data-field="name"]'),
          message: this.querySelector('[data-recipient-field-error][data-field="message"]'),
          send_on: this.querySelector('[data-recipient-field-error][data-field="send_on"]')
        };
        this.messageLimit = Number.parseInt(this.inputMap.message?.dataset.messageLimit || "", 10) || MESSAGE_LIMIT_FALLBACK;
        if (!this.checkbox || !this.hiddenControlField) return;
        this.checkbox.disabled = false;
        this.hiddenControlField.disabled = false;
        this.currentVariantId = this.productForm?.currentVariant?.id ?? null;
        if (this.offsetField) this.offsetField.value = String((new Date).getTimezoneOffset());
        this.checkbox.addEventListener("change", this.onChange);
        this.inputMap.message?.addEventListener("input", this.onMessageInput);
        this.productForm?.addEventListener("product-form:state-updated", this.onProductFormStateUpdated);
        this.productForm?.addEventListener("product-form:add-error", this.onProductFormAddError);
        this.productForm?.addEventListener("product-form:add-success", this.onProductFormAddSuccess);
        this.applyState({
          shouldClearInputs: false,
          shouldClearErrors: false,
          announce: false
        });
        this.updateMessageCounter();
      }
      disconnectedCallback() {
        this.checkbox?.removeEventListener("change", this.onChange);
        this.inputMap.message?.removeEventListener("input", this.onMessageInput);
        this.productForm?.removeEventListener("product-form:state-updated", this.onProductFormStateUpdated);
        this.productForm?.removeEventListener("product-form:add-error", this.onProductFormAddError);
        this.productForm?.removeEventListener("product-form:add-success", this.onProductFormAddSuccess);
      }
      onChange() {
        this.applyState({
          shouldClearInputs: !this.checkbox.checked,
          shouldClearErrors: !this.checkbox.checked,
          announce: true
        });
      }
      onProductFormStateUpdated(event) {
        const nextVariantId = event.detail?.variant?.id ?? null;
        const hasVariantChanged = this.currentVariantId !== null && nextVariantId !== this.currentVariantId;
        this.currentVariantId = nextVariantId;
        if (!this.checkbox) return;
        const isSoldOut = Boolean(event.detail?.variant) && !event.detail.variant.available;
        if ((hasVariantChanged || isSoldOut) && this.checkbox.checked) {
          this.checkbox.checked = false;
          this.applyState({
            shouldClearInputs: true,
            shouldClearErrors: true,
            announce: true
          });
        }
      }
      onProductFormAddError(event) {
        const {isValidationError: isValidationError, message: message, errors: errors} = event.detail || {};
        if (!isValidationError) return;
        if (!this.checkbox.checked) this.checkbox.checked = true;
        this.applyState({
          shouldClearInputs: false,
          shouldClearErrors: false,
          announce: false
        });
        this.displayErrorMessage(message, errors);
      }
      onProductFormAddSuccess() {
        this.clearErrorMessage();
      }
      onMessageInput() {
        this.updateMessageCounter();
      }
      getTodayISO() {
        const now = new Date;
        const year = String(now.getFullYear());
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      initializeSendOnDate() {
        const input = this.inputMap.send_on;
        if (!input || input.disabled) return;
        input.min = this.getTodayISO();
      }
      updateMessageCounter() {
        const messageInput = this.inputMap.message;
        if (!messageInput || !this.messageCounter) return;
        const count = messageInput.value.length;
        const limit = this.messageLimit;
        const nearLimitThreshold = Math.min(limit, MESSAGE_NEAR_LIMIT_THRESHOLD);
        const isNearLimit = count >= nearLimitThreshold && count <= limit;
        const isOverLimit = count > limit;
        const shouldShow = count >= nearLimitThreshold;
        this.messageCounter.textContent = `${count}/${limit}`;
        this.messageCounter.classList.toggle("is-visible", shouldShow);
        this.messageCounter.classList.toggle("is-near-limit", isNearLimit);
        this.messageCounter.classList.toggle("is-over-limit", isOverLimit);
      }
      applyState({shouldClearInputs: shouldClearInputs, shouldClearErrors: shouldClearErrors, announce: announce}) {
        const isEnabled = Boolean(this.checkbox?.checked);
        this.hiddenControlField.value = isEnabled ? "true" : "false";
        this.inputs.forEach(input => {
          input.disabled = !isEnabled;
        });
        if (isEnabled) this.initializeSendOnDate();
        if (this.offsetField) this.offsetField.disabled = !isEnabled;
        if (shouldClearInputs && !isEnabled) this.clearInputFields();
        if (shouldClearErrors && !isEnabled) this.clearErrorMessage();
        if (announce && this.liveRegion) {
          const key = isEnabled ? "recipientExpanded" : "recipientCollapsed";
          this.liveRegion.textContent = window.MBF?.strings?.giftCard?.[key] || "";
        }
        this.updateMessageCounter();
      }
      clearInputFields() {
        this.inputs.forEach(field => {
          if (!field) return;
          field.value = "";
        });
      }
      clearErrorMessage() {
        if (this.errorSummary) {
          this.errorSummary.hidden = true;
          if (this.errorSummaryList) this.errorSummaryList.innerHTML = "";
        }
        this.errorFieldEls.forEach(field => {
          field.classList.add("hidden");
          const text = field.querySelector(".error-message");
          if (text) text.textContent = "";
        });
        this.inputs.forEach(input => {
          input.setAttribute("aria-invalid", "false");
          input.removeAttribute("aria-describedby");
        });
      }
      createSummaryItem({input: input, message: message}) {
        const li = document.createElement("li");
        if (input?.id) {
          const a = document.createElement("a");
          a.href = `#${input.id}`;
          a.textContent = message;
          li.appendChild(a);
        } else li.textContent = message;
        return li;
      }
      toMessage(value) {
        if (Array.isArray(value)) return value.join(", ");
        if (value === null || value === undefined) return "";
        return String(value);
      }
      displayErrorMessage(message, errors = null) {
        this.clearErrorMessage();
        if (!this.errorSummary) return;
        this.errorSummary.hidden = false;
        const hasFieldErrors = errors && typeof errors === "object";
        if (!hasFieldErrors) {
          if (this.errorSummaryList && message) this.errorSummaryList.appendChild(this.createSummaryItem({
            input: null,
            message: message
          }));
          return;
        }
        let summaryCount = 0;
        Object.entries(errors).forEach(([fieldKey, rawValue]) => {
          const text = this.toMessage(rawValue);
          if (!text) return;
          const input = this.inputMap[fieldKey] || null;
          const errorEl = this.errorMap[fieldKey] || null;
          const errorTextEl = errorEl?.querySelector(".error-message");
          if (this.errorSummaryList) {
            this.errorSummaryList.appendChild(this.createSummaryItem({
              input: input,
              message: text
            }));
            summaryCount += 1;
          }
          if (errorEl && errorTextEl) {
            errorTextEl.textContent = `${text}.`;
            errorEl.classList.remove("hidden");
          }
          if (input && errorEl?.id) {
            input.setAttribute("aria-invalid", "true");
            input.setAttribute("aria-describedby", errorEl.id);
          }
        });
        if (!summaryCount && this.errorSummaryList && message) this.errorSummaryList.appendChild(this.createSummaryItem({
          input: null,
          message: message
        }));
      }
    });
  })();
})();